<template>
  <div v-if="userStore.isLoading">
    <span class="loading loading-spinner loading-lg text-base-content/60"></span>
  </div>
  <div v-else class="tabs tabs-border">
    <input
      type="radio"
      name="user_profile_tabs"
      class="tab"
      aria-label="Bendra informacija"
      checked="checked"
    />
    <div class="tab-content bg-base-100 rounded-lg p-6">
      <div>
        <div class="flex justify-between items-center mb-6">
          <div class="relative">
            <div
              class="avatar placeholder"
              :class="
                userFormData.status === 'working'
                  ? 'avatar-online '
                  : 'avatar-offline'
              "
            >
              <div
                class="bg-neutral text-neutral-content w-12 h-12 rounded-full place-content-center text-center"
              >
                <span v-if="userFormData" class="text-xl font-bold">{{
                  userFormData.initials
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="space-y-6">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <fieldset class="fieldset w-full">
              <legend class="fieldset-legend">Vardas</legend>
              <input
                v-model="userFormData.name"
                type="text"
                class="input w-full"
                disabled
              />
            </fieldset>

            <fieldset class="fieldset w-full">
              <legend class="fieldset-legend">Pavardė</legend>
              <input
                v-model="userFormData.surname"
                type="text"
                class="input w-full"
                disabled
              />
            </fieldset>

            <fieldset class="fieldset w-full">
              <legend class="fieldset-legend">Telefonas</legend>
              <div class="relative">
                <input
                  v-model="userFormData.phone"
                  type="text"
                  maxlength="8"
                  class="input w-full"
                  disabled
                />
              </div>
            </fieldset>

            <fieldset class="fieldset w-full">
              <legend class="fieldset-legend">El. paštas</legend>
              <input
                v-model="userFormData.email"
                type="email"
                class="input w-full"
                disabled
              />
            </fieldset>
          </div>

          <div class="grid grid-cols-1 gap-2 mb-6 opacity-70 text-sm">
            <div>Organizacija: {{ userFormData.organization_name }}</div>
            <div>
              Pareigos:
              {{ roleConfig[userFormData.role]?.text || userFormData.role }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <input
      type="radio"
      name="user_profile_tabs"
      class="tab"
      aria-label="Atostogos"
    />
    <div class="tab-content bg-base-100 rounded-lg p-6">
      <div v-if="holidayStore.isLoading" class="text-center py-4">
        <span class="loading loading-spinner loading-lg"></span>
      </div>

      <div v-else class="overflow-x-auto">
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-xl font-semibold">Atostogų sąrašas</h2>
          <div>
            <button
              class="btn btn-sm btn-outline"
              @click="showHolidayFormModal = true"
            >
              <DefaultIcon name="plus" size="w-4 h-4" />
              Įtraukti naujas
            </button>
          </div>
        </div>
        <div v-if="holidayStore.holidays.length > 0">
          <table class="table w-full mb-3">
            <thead>
              <tr>
                <th>Pradžios data</th>
                <th>Pabaigos data</th>
                <th>Pastaba</th>
                <th>Įtraukta</th>
                <th>Redaguota</th>
                <th v-if="displayAction">Veiksmai</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="holiday in holidayStore.holidays" :key="holiday.id">
                <td>{{ holiday.start_date }}</td>
                <td>{{ holiday.end_date }}</td>
                <td>{{ holiday.description }}</td>
                <td>{{ holiday.created_at }}</td>
                <td>{{ holiday.updated_at }}</td>
                <td v-if="displayAction">
                  <button
                    class="btn btn-sm btn-ghost btn-circle"
                    title="Ištrinti atostogų įrašą"
                    @click="deleteHoliday(holiday.id)"
                  >
                    <DefaultIcon name="trash" size="w-4 h-4" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>Darbuotojui atostogų dar nesuplanuota.</div>
      </div>
    </div>
    <!-- Form Modal -->
    <Modal
      title="Įtraukti naujas atostogas"
      :is-open="showHolidayFormModal"
      @close="showHolidayFormModal = false"
    >
      <Alert
        v-if="holdayCreationError"
        :text="holdayCreationError"
        alert-class="alert-error"
        icon="warning"
        :dismissible="false"
        class="mb-6"
      />
      <form @submit.prevent="submitForm">
        <div class="grid grid-cols-2 gap-4 mb-6">
          <fieldset class="fieldset w-full">
            <legend class="fieldset-legend">Pradžia*</legend>
            <div class="relative">
              <input
                v-model="holidayFormData.start_date"
                type="date"
                maxlength="8"
                class="input validator w-full"
                required
              />
            </div>
          </fieldset>
          <fieldset class="fieldset w-full">
            <legend class="fieldset-legend">Pabaiga*</legend>
            <div class="relative">
              <input
                v-model="holidayFormData.end_date"
                type="date"
                maxlength="8"
                class="input validator w-full"
                required
              />
            </div>
          </fieldset>
        </div>
        <div class="grid grid-cols-1 gap-4 mb-6">
          <fieldset class="fieldset w-full">
            <legend class="fieldset-legend">Pastaba</legend>
            <div class="relative">
              <textarea
                v-model="holidayFormData.description"
                type="date"
                maxlength="1000"
                class="textarea w-full"
              />
            </div>
          </fieldset>
        </div>
      </form>

      <template #footer>
        <button
          @click="createHoliday"
          class="btn btn-primary mr-2"
          :disabled="!holidayFormData.end_date || !holidayFormData.start_date"
        >
          Sukurti
        </button>
        <button @click="showHolidayFormModal = false" class="btn btn-ghost">
          Atšaukti
        </button>
      </template>
    </Modal>
    <Toast ref="toast" />
  </div>
</template>

<script setup>
import { useAuthStore } from "@/stores/auth";
import { useHolidayStore } from "@/stores/holidays";
import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";

import Modal from "@/components/ui/modals/GeneralModal.vue";
import DefaultIcon from "@/components/icons/DefaultIcon.vue";
import Toast from "@/components/ui/alerts/ToastComponent.vue";
import Alert from "@/components/ui/alerts/DefaultAlert.vue";

const route = useRoute();
const router = useRouter();
const userStore = useAuthStore();
const holidayStore = useHolidayStore();

const showHolidayFormModal = ref(false);
const toast = ref(null);
const holdayCreationError = ref(null);

const userFormData = ref({
  id: null,
  name: null,
  surname: null,
  email: null,
  phone: null,
  itinials: null,
  role: null,
  status: null,
  holidays: [],
  organization_id: null,
  organization_name: null,
});

const holidayFormData = ref({
  start_date: null,
  end_date: null,
  description: null,
});

const roleConfig = {
  driver: {
    text: "Vairuotojas",
  },
  planner: {
    text: "Planuotojas",
  },
};

onMounted(async () => {
  try {
    const user = await userStore.fetchUserById(route.params.id);
    if (user) {
      userFormData.value = { ...user };
      await holidayStore.fetchHolidays(route.params.id);
    } else {
      router.push("/users");
    }
  } catch (error) {
    console.error("Failed to fetch users:", error);
    router.push("/users");
  }
});

const createHoliday = async () => {
  try {
    await holidayStore.addHoliday(route.params.id, holidayFormData.value);
    showHolidayFormModal.value = false;
    toast.value.success("Atostogų įrašas sukurtas", 5000);
    holdayCreationError.value = null;
    resetHolidayForm();
  } catch (error) {
    holdayCreationError.value = error;
    console.log(holdayCreationError.value);
  }
};

const deleteHoliday = async (holidayId) => {
  if (confirm("Ar tikrai norite ištrinti suplanuotų atostogų įrašą?")) {
    try {
      await holidayStore.deleteHoliday(route.params.id, holidayId);
      toast.value.success("Atostogų įrašas ištrintas", 5000);
    } catch {
      toast.value.error("Atostogų įrašo ištrinti nepavyko", 5000);
    }
  }
};

const resetHolidayForm = () => {
  holidayFormData.value = {
    start_date: null,
    end_date: null,
    description: null,
  };
};

const displayAction = computed(() => {
  return userStore.user.role === "planner";
});
</script>
